// box-edges.mjs

// For each view, specify which face/corners to draw
export const BOX_FACE_INDICES = {
   top: [0, 1, 5, 4],
   side: [0, 1, 2, 3],
   front: [0, 4, 7, 3],
};

// Define the 12 edges of a box by index pairs
export const BOX_EDGES = [
   [0, 1],
   [1, 2],
   [2, 3],
   [3, 0], // bottom
   [4, 5],
   [5, 6],
   [6, 7],
   [7, 4], // top
   [0, 4],
   [1, 5],
   [2, 6],
   [3, 7], // sides
];
